// AUTO-WA-39: a subset of the main app's AUTO-319 character library (same keys
// and art), used to give each WhatsApp bot a face. A character is only a look.
import appy from './assets/characters/appy.webp';
import tara from './assets/characters/tara.webp';
import remy from './assets/characters/remy.webp';
import atlas from './assets/characters/atlas.webp';
import echo from './assets/characters/echo.webp';
import maya from './assets/characters/maya.webp';
import kiran from './assets/characters/kiran.webp';
import nila from './assets/characters/nila.webp';
import hari from './assets/characters/hari.webp';
import sia from './assets/characters/sia.webp';
import appyFull from './assets/characters/appy-full.webp';
import taraFull from './assets/characters/tara-full.webp';
import nilaFull from './assets/characters/nila-full.webp';

export const CHARACTERS = [
  { key: 'appy', tint: '#E3EFF7', image: appy, full: appyFull },
  { key: 'tara', tint: '#DBF0EB', image: tara, full: taraFull },
  { key: 'nila', tint: '#E1EBF8', image: nila, full: nilaFull },
  { key: 'remy', tint: '#F7EAD1', image: remy },
  { key: 'atlas', tint: '#DDE6F6', image: atlas },
  { key: 'echo', tint: '#DCEEEF', image: echo },
  { key: 'maya', tint: '#E7EDDF', image: maya },
  { key: 'kiran', tint: '#EAE8D6', image: kiran },
  { key: 'hari', tint: '#F6E9C9', image: hari },
  { key: 'sia', tint: '#EDE6F5', image: sia },
];

const byKey = Object.fromEntries(CHARACTERS.map((character) => [character.key, character]));

export const characterFor = (key) => (key && byKey[key]) || null;

// A stable look for a bot that has no chosen character: same id, same face.
export function characterForId(id = '') {
  let hash = 0;
  for (const char of String(id)) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return CHARACTERS[hash % CHARACTERS.length];
}
